import { render, staticRenderFns } from "./propHighlight.vue?vue&type=template&id=609b5dd4&"
import script from "./propHighlight.vue?vue&type=script&lang=js&"
export * from "./propHighlight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports